export default "__VITE_ASSET__DippIkw4__"